import CreateBanner from "./CreateBanner";


export default function FoodBanner() {
    return (
        <div>
            <CreateBanner Type={"FOOD"} />
        </div>
    )
}